import { ENDPOINT } from "../config/api";

function getPaymentStartByType(paymentType) {
  switch (paymentType) {
    case "premium":
      return ENDPOINT.premiumStartPayment;
    case "parent":
      return ENDPOINT.parentStartPayment;
    case "mobile":
      return ENDPOINT.startPayment;
    case "therapist_client":
      return ENDPOINT.therapistClientStartPayment;
    case "partner":
      return ENDPOINT.premiumStartPayment;
    default:
      return ENDPOINT.startPayment;
  }
}

function getPaymentConfirmByType(paymentType) {
  switch (paymentType) {
    case "premium":
      return ENDPOINT.premiumConfirmPayment;
    case "parent":
      return ENDPOINT.parentConfirmPayment;
    case "mobile":
      return ENDPOINT.confirmPayment;
    case "therapist_client":
      return ENDPOINT.therapistClientConfirmPayment;
    case "partner":
      return ENDPOINT.premiumConfirmPayment;
    default:
      return ENDPOINT.confirmPayment;
  }
}

function getPaymentSummaryByType(paymentType) {
  switch (paymentType) {
    case "premium":
      return ENDPOINT.premiumSummary;
    case "parent":
      return ENDPOINT.parentSummary;
    case "mobile":
      return ENDPOINT.purchaseSummary;
    case "therapist_client":
      return ENDPOINT.therapistClientSummary;
    case "partner":
      return ENDPOINT.premiumSummary;
    default:
      return ENDPOINT.purchaseSummary;
  }
}

export {
  getPaymentStartByType,
  getPaymentConfirmByType,
  getPaymentSummaryByType,
};
